// MenuWrapper.jsx
import React, { useState, useEffect } from 'react';
import Menu from './Menu'; // Votre Menu.js original
import ConfigurationManager from './ConfigurationManager';

const MenuWrapper = () => {
  const [config, setConfig] = useState(null);
  const [saleMode, setSaleMode] = useState('dineIn');
  
  useEffect(() => {
    // Initialiser la configuration
    const initializedConfig = ConfigurationManager.init();
    setConfig(initializedConfig.config);
    
    // Déterminer le mode de vente
    const defaultMode = initializedConfig.getDefaultSaleMode();
    setSaleMode(defaultMode);
    
    // Appliquer les configurations selon le type de restaurant
    if (!initializedConfig.config.restaurant.hasTables) {
      console.log("Mode foodtrack activé - pas de tables");
    }
  }, []);
  
  // Si pas encore initialisé
  if (!config) {
    return <div>Chargement de la configuration...</div>;
  }
  
  // Fonction pour adapter les props selon la configuration
  const getAdaptedProps = () => {
    const adaptedProps = {
      // Props de base
      user: { /* vos données utilisateur */ },
      
      // Override des comportements selon configuration
      config: {
        // Informations restaurant
        restaurantType: config.restaurant.type,
        hasTables: config.restaurant.hasTables,
        
        // Fonctionnalités activées
        features: config.features,
        
        // Sections visibles
        ui: config.ui,
        
        // Promotions
        promotions: config.promotions
      }
    };
    
    return adaptedProps;
  };
  
  // Rendu conditionnel selon le mode
  if (!config.features.tableSystem.enabled && config.restaurant.type === 'foodtrack') {
    // Mode foodtrack - vente directe sans tables
    return (
      <div className="foodtrack-mode">
        <div className="foodtrack-header">
          <h1>{config.restaurant.name} - VENTE DIRECTE</h1>
          <div className="sale-info">
            <span>Mode: Vente Directe</span>
            <span>•</span>
            <span>Pas de tables</span>
            <span>•</span>
            <span>Paiement immédiat</span>
          </div>
        </div>
        
        {/* On passe le Menu original avec des props adaptées */}
        <Menu {...getAdaptedProps()} />
        
        {/* Ajouter un panneau de contrôle rapide */}
        <div className="quick-controls">
          <button onClick={() => window.open('/admin/promotions', '_blank')}>
            Gérer les Promotions
          </button>
          <button onClick={() => ConfigurationManager.getAdminInterface().toggleUISection('tablesSection', true)}>
            Activer les Tables
          </button>
        </div>
      </div>
    );
  }
  
  // Mode restaurant normal avec tables
  return (
    <div className="restaurant-mode">
      <Menu {...getAdaptedProps()} />
    </div>
  );
};

export default MenuWrapper;